export const listProperties = {
  properties: {
    styles: {
      listTypes: ['bulleted', 'numbered'],
      listStyleTypes: {
        numbered: ['decimal', 'decimal-leading-zero', 'lower-roman', 'upper-roman', 'lower-latin', 'upper-latin'],
        bulleted: ['disc', 'circle', 'square'],
      },
    },
    startIndex: true,
    reversed: true,
  },
};

export const TemplateEditorErrors = {
  COMMENT_THREAD_UPDATE: {
    id: 'DocumentCommentsDrawer.comment-thread-update-error',
    defaultMessage: 'Unable to update comment thread',
  },
  COMMENT_UPDATE: {
    id: 'DocumentCommentsDrawer.comment-update-error',
    defaultMessage: 'Unable to update comment',
  },
  COMMENT_THREAD_RESOLVE: {
    id: 'DocumentCommentsDrawer.comment-thread-resolve-error',
    defaultMessage: 'Unable to resolve comment thread',
  },
  COMMENT_CREATE: {
    id: 'DocumentCommentsDrawer.comment-creation-error',
    defaultMessage: 'Unable to create comment',
  },
  COMMENT_THREAD_CREATE: {
    id: 'DocumentCommentsDrawer.comment-thread-creation-error',
    defaultMessage: 'Unable to create comment thread',
  },
  COMMENT_REOPEN: {
    id: 'DocumentCommentsDrawer.comment-reopen-error',
    defaultMessage: 'Unable to reopen comment thread',
  },
  COMMENT_REMOVE: {
    id: 'DocumentCommentsDrawer.comment-remove-error',
    defaultMessage: 'Unable to remove comment',
  },
  COMMENT_THREAD_REMOVE: {
    id: 'DocumentCommentsDrawer.comment-thread-remove-error',
    defaultMessage: 'Unable to remove comment thread',
  },
  RENAME_TITLE: {
    id: 'document-wizard.header.hover.title',
    defaultMessage: 'Rename title',
  },
};

export const DocumentEditorErrors = {
  NO_POSSESSION: {
    id: 'LeaseDocumentError.no-possession',
    defaultMessage:
      'This document is currently in the possession of the other party. You and your teammates will not be able to edit until possession has been passed back to you.',
  },
  IS_LOCKED: {
    id: 'LeaseDocumentError.is-locked',
    defaultMessage:
      'This document is currently being edited by another user. The contents may be changing, and you will not be able to edit until they have finished.',
  },
  TEMPLATE_IS_LOCKED: {
    id: 'DocumentTemplateError.is-locked',
    defaultMessage:
      'This template is currently being edited by another user. The contents may be changing, and you will not be able to edit until they have finished.',
  },
  IS_PREPARING_TO_SIGN: {
    id: 'LeaseDocumentError.is-preparing-to-sign',
    defaultMessage:
      'This document is being prepared for signing and cannot be accessed until this is completed by your counterparty',
  },
};

export const successSendDocumentMessage = {
  id: 'lease-document-wizard-preview-send-offer.send.success',
  defaultMessage: 'Success! Your document has been shared with all parties on the deal.',
};

export const givePossessionSuccessMessage = {
  id: 'lease-document-wizard-give-possession-offer.send.success',
  defaultMessage: 'The document has been successfully sent for counterparty review.',
};

export const successGrantAccessMessage = {
  id: 'document-grant-access.success',
  defaultMessage: 'Success! Your deal has been shared with {email}.',
};

export const MIN_WINDOW_WIDTH_FOR_WIDE_SIDEBAR = 1500;

export const formattingOptions = [
  'heading',
  'Bold',
  'Italic',
  'Underline',
  'Highlight',
  'FontSize',
  'FontFamily',
  'FontColor',
  'fontBackgroundColor',
  'Indent',
  'Outdent',
  'alignment',
  'numberedList',
  'bulletedList',
];

export const toolbarItems = (
  isDocumentCreator: boolean,
  userCommentArchivePermission: boolean,
  disableWordExport: boolean = false,
  canEdit: boolean = false
) => {
  return [
    isDocumentCreator && canEdit ? 'editHeaderFooter' : '|', // Header/footer editor button - only for creators with edit permission
    '|',
    'bold',
    'italic',
    'underline',
    'strikethrough',
    '|',
    'highlight',
    '|',
    'heading',
    'fontSize',
    'fontFamily',
    'fontColor',
    'fontBackgroundColor',
    'lineHeight',
    '|',
    'indent',
    'outdent',
    'alignment',
    '|',
    'numberedList',
    'bulletedList',
    '|',
    'pageBreak',
    '|',
    'undo',
    'redo',
    '|',
    'findAndReplace',
    '|',
    isDocumentCreator ? 'trackChanges' : '|',
  ].filter(Boolean);
};

export const restrictedFormattingOptions = [
  'heading',
  'Bold',
  'Italic',
  'Underline',
  'Strikethrough',
  'Highlight',
  'FontSize',
  'FontFamily',
  'FontColor',
  'fontBackgroundColor',
];

export const restrictedToolbarItems = (
  isDocumentCreator: boolean,
  disableWordExport: boolean = false,
  canEdit: boolean = false
) => {
  return [
    isDocumentCreator && canEdit ? 'editHeaderFooter' : '|', // Header/footer editor button - only for creators with edit permission
    '|',
    'bold',
    'italic',
    'underline',
    'strikethrough',
    '|',
    'highlight',
    '|',
    'heading',
    'fontSize',
    'fontFamily',
    'fontColor',
    'fontBackgroundColor',
    'lineHeight',
    '|',
    'indent',
    'outdent',
    'alignment',
    '|',
    'numberedList',
    'bulletedList',
    '|',
    isDocumentCreator ? 'trackChanges' : '|',
  ].filter(Boolean);
};

export const restrictedToolbar = [
  'bold',
  'italic',
  'underline',
  'strikethrough',
  'highlight',
  'fontSize',
  'fontFamily',
  'fontColor',
  'fontBackgroundColor',
  'lineHeight',
  'insertImage',
  'resizeImage',
  'uploadImage',
  'imageStyle',
  'imageTypeInline',
  'imageTextAlternative',
  'imageInsert',
  'insertInlineCheckbox',
  'toggleInlineCheckbox',
  'placeholder',
  'showCustomDialog',
  'hideDialogCommand',
  'replacePlaceholder',
];

export const ShareWithUnresolvedSuggestionsWarning = {
  title: 'Suggestions still pending',
  text: 'This document has {num} counterparty suggestion(s) pending which must be accepted or discarded by your team before the document can be signed.',
};
export enum DocumentSourceEnum {
  APP = 'app',
  IMPORTED = 'imported',
}

export const TRACK_CHANGES_BUTTON_LABEL = 'Track changes';

export const DOCUMENT_RECEIVER_WARNING = `Edit document to make suggestions, highlight to comment, and then send to review or sign when you're ready.`;

export const DUPLICATE_EMAIL_WARNING =
  'This email is already a member of this deal team. Manage their permissions from the participants sidebar';
export const PENDING_EMAIL_WARNING =
  'This email has a pending invite to this deal team already. Send them a reminder from the participants sidebar.';
export const ORG_MEMBER_EMAIL_WARNING =
  "This email is a member of this workspace already. Add them to this deal team from the participant sidebar's Existing Team Members dropdown.";

export const ATTACHMENTS_COUNTERPARTY_WARNING = 'Counterparty can view attachments.';

export const INCLUDE_ATTACHMENTS_TOOLTIP = 'Documents and attachments will be combined into a single file.';

export const INCLUDE_ATTACHMENTS_TOOLTIP_SIZE_WARNING = `File size is too large to email. ${INCLUDE_ATTACHMENTS_TOOLTIP}`;
